export default {
  postMessage(
    data: object,
    targetOrigin: string,
    element: string = 'storyblok-preview',
  ): void {
    const ref = String(targetOrigin).split('/')

    if (!ref[0] || !ref[2]) {
      return
    }

    const iframe = document.getElementById(element) as HTMLIFrameElement

    if (iframe && iframe.contentWindow) {
      iframe?.contentWindow?.postMessage(data, ref[0] + '//' + ref[2])
    }
  },
}
